import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { l as label, i as input, b as inputInvalid, c as inputDisabled, d as inputFocused } from './parts.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';
import { d as defineCustomElement$2 } from './custom-popper2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const DateInput = /*@__PURE__*/ proxyCustomElement(class DateInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.handleFormControlInput = (event) => {
            const dateValue = event.target.value;
            this.inputHandler(this.name, dateValue);
            this.formControlInput.emit({ name: this.name, value: dateValue });
        };
        this.isFocused = false;
        this.name = undefined;
        this.label = undefined;
        this.inputHandler = undefined;
        this.defaultValue = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.disabled = undefined;
        this.showTime = undefined;
        this.maxDate = this.currentDate;
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    get currentDate() {
        if (!this.showTime) {
            return new Date().toISOString().split('T')[0];
        }
        else {
            return new Date().toISOString().slice(0, 16);
        }
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    updateInput(value) {
        this.dateInput.value = value;
    }
    get part() {
        let part = input;
        if (this.errorText) {
            part = inputInvalid;
        }
        if (this.disabled) {
            part = inputDisabled;
        }
        if (this.isFocused) {
            part = inputFocused;
        }
        return part;
    }
    render() {
        return (h(Host, { key: 'a2e8ffbb23d128699730acd686fc06ce0ade5270' }, h("div", { key: 'd43b72838047707022bd3527b610eec234af6cd9', class: "form-group d-flex flex-column" }, h("div", { key: '416954342c2113ff1f4fc77cf714852e0bb66527', class: "d-flex gap-2" }, h("label", { key: 'e0c366b390fbb3ef8d183b5ca71935b8274a0b22', part: label, class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: 'e4aa76ce751db6fa45a8f11f8026e68102f484f4', helpText: this.helpText })), h("input", { key: '4022e4c857527cffb19b747815acad73c81025d4', type: this.showTime ? 'datetime-local' : 'date', ref: el => (this.dateInput = el), id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, part: this.part, class: this.errorText ? 'form-control is-invalid' : 'form-control', disabled: this.disabled, max: this.maxDate }), h(FormControlErrorText, { key: '31c0122e9737c704b087dbb2a4791fd7965be3c7', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-date", {
        "name": [1],
        "label": [1],
        "inputHandler": [16],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "disabled": [4],
        "showTime": [4, "show-time"],
        "maxDate": [1, "max-date"],
        "isFocused": [32]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-date", "custom-popper", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-date":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, DateInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { DateInput as D, defineCustomElement as d };
